import React, { Component } from 'react';
import Checkbox from 'material-ui/Checkbox';

import styles from '../../../styles.js';
import './filterSideBar.css';

class ComingSoon extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage0: ''
    };
  }

  render() {
    const { cities = [] } = this.props;
    return cities.map((name, i) => (
      <div key={name}>
        <Checkbox
          checked={false}
          onCheck={() =>
            this.setState({
              [`errorMessage${i}`]: 'COMING SOON!'
            })
          }
          iconStyle={styles.CheckboxFilterMui}
          label={name}
          labelPosition="left"
          labelStyle={styles.LabelFilterMui}
        />
        {this.state[
          `errorMessage${Object.keys(this.state).length - 1}`
        ] ? (
          <p className="coming-soon">{this.state[`errorMessage${i}`]}</p>
        ) : null}
      </div>
    ));
  }
}

export default ComingSoon;



// WEBPACK FOOTER //
// ./src/components/Book/FilterSidebar/ComingSoon.js